import { ISettingInfo, IWritableSettings } from '@barthauer/abc/core';

export enum LegendSetting {
  visibility,
  viewbox,
  expansion,
}

export interface ILegendSettings {
  readonly visibility: {};
  viewbox: number[];
  readonly expansion: {};
}

export class LegendSettings implements ILegendSettings, IWritableSettings<ILegendSettings> {
  public static readonly Infos: ReadonlyMap<LegendSetting, ISettingInfo> = new Map<LegendSetting, ISettingInfo>([
    [
      LegendSetting.visibility,
      { settingName: 'visibility', responsePropertyName: 'visibility', settingValueType: Object },
    ],
    [LegendSetting.viewbox, { settingName: 'viewbox', responsePropertyName: 'viewbox', settingValueType: Object }],
    [
      LegendSetting.expansion,
      { settingName: 'expansion', responsePropertyName: 'expansion', settingValueType: Object },
    ],
  ]);

  visibility: {} = {};
  viewbox: number[] = [];
  expansion: {} = {};

  load(settings: ILegendSettings): void {
    if (settings) {
      this.visibility = settings.visibility ?? {};
      this.viewbox = settings.viewbox ?? [];
      this.expansion = settings.expansion ?? {};
    }
  }
}
